'use client';

import React from 'react';
import styled from 'styled-components';

export interface MapScaleProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Distance label, e.g. "500 m", "1 km". */
  label: string;
  /** Bar width in px. Default 80. */
  width?: number;
}

const Root = styled.div`
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  padding: 4px 6px;
  background: ${(p) => p.theme.colors.neutral.panel};
  border: 1px solid ${(p) => p.theme.colors.neutral.line};
  border-radius: ${(p) => p.theme.radius.sm};
  box-shadow: ${(p) => p.theme.elevation.raised.shadow};
  font-family: ${(p) => p.theme.fontFamily.mono};
  font-size: ${(p) => p.theme.fontSize.xs};
  color: ${(p) => p.theme.colors.neutral.inkSoft};
`;

const Bar = styled.div`
  height: 4px;
  border: 1px solid ${(p) => p.theme.colors.neutral.inkSoft};
  border-bottom: 2px solid ${(p) => p.theme.colors.neutral.ink};
`;

/**
 * Compact map scale-bar overlay. Renders a stamped line + label,
 * intended to sit absolutely-positioned inside a `MapLayout.Canvas`
 * (typically bottom-right). The consumer owns the conversion between
 * screen pixels and the label text.
 */
export function MapScale({ label, width = 80, ...rest }: MapScaleProps) {
  return (
    <Root {...rest}>
      <Bar data-map-scale-bar style={{ width: `${width}px` }} />
      <span>{label}</span>
    </Root>
  );
}
